import React from 'react';
import { ToolbarIcon } from '@instinet-analytics/semantic-ui-components';

export function DownloadScreenshotButton(props: {
    fileName: string;
    screenshot?: string;
}) {
    const { fileName, screenshot } = props;

    const downloadScreenshot = () => {
        const link = document.createElement('a');
        link.download = fileName;
        link.href = screenshot!;

        document.body.appendChild(link);

        link.dispatchEvent(
            new MouseEvent('click', {
                bubbles: false,
                cancelable: true,
                view: window,
            })
        );

        document.body.removeChild(link);
    };

    if (!screenshot) {
        return <></>;
    }

    return (
        <ToolbarIcon
            name="download"
            className="DownloadScreenshotButton"
            tooltip="Download Screenshot"
            onClick={downloadScreenshot}
        />
    );
}
